import { render, staticRenderFns } from "./Co_Applications.vue?vue&type=template&id=6a415ea2&scoped=true"
import script from "./Co_Applications.vue?vue&type=script&setup=true&lang=js"
export * from "./Co_Applications.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Co_Applications.vue?vue&type=style&index=0&id=6a415ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a415ea2",
  null
  
)

export default component.exports